import { styled } from '@mui/material/styles';

import color from 'atoms/colors/colors';

declare module '@mui/material/Radio' {
  interface RadioPropsSizeOverrides {
    large: true;
    medium: false;
  }
}

const radioRoot = {
  padding: '4px',
  marginTop: '4px',
  marginRight: '4px',
  alignSelf: 'flex-start',
};

export const RadioIcon = styled('span', {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'large' | undefined }>(({ size }) => ({
  width: size === 'small' ? 16 : 20,
  height: size === 'small' ? 16 : 20,
  borderRadius: '50%',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: color.storm[300],
  display: 'inline-block',
  position: 'relative',
  transition: 'all .3s',
  boxShadow: '0px 0px 0px 0px #F4EBFF',
  // zIndex: 10,
  'input:not([disabled]):hover ~ &': {
    backgroundColor: color.storm[100],
    borderColor: color.wave[800],
  },
  'input:focus ~ &': {
    boxShadow: '0px 0px 0px 4px #F4EBFF',
  },
  'input[disabled] ~ &': {
    backgroundColor: color.storm[100],
    borderColor: color.storm[300],
  },
}));

export const CheckedIcon = styled(RadioIcon, {
  shouldForwardProp: prop => prop !== 'size',
})<{ size: 'small' | 'large' | undefined }>(({ size }) => ({
  backgroundColor: color.storm[50],
  '&:before': {
    display: 'block',
    width: size === 'small' ? 6 : 8,
    height: size === 'small' ? 6 : 8,
    borderRadius: '50%',
    backgroundColor: color.wave[800],
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  'input[disabled] ~ &': {
    '&:before': {
      backgroundColor: color.storm[300],
    },
  },
}));

export const darkRadio = {
  MuiRadio: {
    styleOverrides: {
      root: {
        color: color.cloud[600],
        ...radioRoot,
        '&:hover': {
          backgroundColor: color.cloud[700],
          color: color.storm[700],
        },
      },
    },
  },
};

export const lightRadio = {
  MuiRadio: {
    styleOverrides: {
      root: {
        color: color.cloud[300],
        ...radioRoot,
        '&:hover': {
          backgroundColor: color.storm[50],
          color: color.storm[600],
        },
        '.MuiTouchRipple-root': {
          '.MuiTouchRipple-rippleVisible': {
            '.MuiTouchRipple-child': {},
          },
        },
      },
    },
  },
};
